import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/super-admin";

export const superAdminApi = {
  getPlatformHealth: () => apiGet<{ data: Record<string, unknown> }>(`${BASE}/health`),

  getPlatformStats: () => apiGet<{ data: Record<string, unknown> }>(`${BASE}/stats`),

  getAllUsers: (params?: PaginatedParams & { role?: string; search?: string; status?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.role) searchParams.set("role", params.role);
    if (params?.search) searchParams.set("search", params.search);
    if (params?.status) searchParams.set("status", params.status);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/users?${searchParams.toString()}`);
  },

  forceDeleteUser: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`${BASE}/users/${id}`),

  getFullAuditLogs: (params?: PaginatedParams & { userId?: string; action?: string; startDate?: string; endDate?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.userId) searchParams.set("userId", params.userId);
    if (params?.action) searchParams.set("action", params.action);
    if (params?.startDate) searchParams.set("startDate", params.startDate);
    if (params?.endDate) searchParams.set("endDate", params.endDate);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/audit-logs?${searchParams.toString()}`);
  },

  impersonateUser: (userId: string, reason?: string) => apiPost<{ data: Record<string, unknown> }>(`${BASE}/impersonate/${userId}`, { reason }),

  getImpersonationLogs: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/impersonation-logs?${searchParams.toString()}`);
  },
};